import { useSelector } from 'react-redux';

import { bedsTitleSelector } from '@zoopla/redux-reducer-filters';

export const useSelectBedsTitle = () => useSelector(bedsTitleSelector);
